import dayjs from "dayjs";

export const canRescheduleAccepted = (influencer: {
  tabStatus?: string;

  applicationDate?: {
    date?: string;
    hour?: string;
  };
}) => {
  if (!influencer) return false;
  const status = String(influencer?.tabStatus ?? "").toLowerCase();
  if (status !== "accepted") return false;

  const app = influencer?.applicationDate;
  if (!app) return false;

  const baseDate = app.date ? dayjs(app.date) : null;
  if (!baseDate || !baseDate.isValid()) return false;

  let scheduled = baseDate;
  if (app.hour) {
    const parsedTime = dayjs(app.hour, "h:mm A");
    if (parsedTime.isValid()) {
      scheduled = scheduled
        .hour(parsedTime.hour())
        .minute(parsedTime.minute())
        .second(0)
        .millisecond(0);
    }
  }

  return scheduled.isAfter(dayjs().add(3, "hour"));
};
